module.exports = __webpack_public_path__ + "static/media/MenuAiTraining.96bbba0c.svg";